module.exports = __webpack_public_path__ + "static/clientgroup-5beba0e3c95f572c61aa4e0e4be230fe.jpg";